import { render, staticRenderFns } from "./why-buy-banner.vue?vue&type=template&id=612ebd22&scoped=true&"
import script from "./why-buy-banner.vue?vue&type=script&lang=js&"
export * from "./why-buy-banner.vue?vue&type=script&lang=js&"
import style0 from "./why-buy-banner.vue?vue&type=style&index=0&id=612ebd22&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612ebd22",
  null
  
)

export default component.exports